
import { BaseViewModel, IEntityConstructorOptions } from "./Base/BaseViewModel";
import { ItemsManager } from "./Services/ItemsManager";
import { GetCorrelation, ICorrelation } from "./Utilities";
import { SimpleTextViewModel } from "./SimpleTextViewModel";
import { DataServices } from "../Services/DataService/DataService";
import { Models, DailyEntry, DailyEntryProperties, DataEntityBase } from "../Services/DataService/Model";
import { CompareFocus, CurrentDaysFocus } from "../Services/DataService/Model/DailyEntry";
import { GetToday } from "../Services/Utilities";
import { PeriodType, RecapEntriesViewModel } from "./RecapEntriesViewModel";
import { RecapEntry, RecapEntryProperties, RecapEntryType, RecapStatus } from "../Services/DataService/Model/RecapEntry";
import { JournalStrings } from "../AppRoutes/Journal/SharedComponents/JournalStrings";
import { ModelManager } from "./ModelManager";
import { BaseProperties } from "../Services/DataService/Model/Base/DataEntityBase";
import { IConstructorOptions, IProperyChangedArgs } from "../Utilities";
import { BasicEntityWatcher } from "../Services/DataService/EntityWatcher";

export type TodayStatus = "notStarted" | "inProgress" | "complete";
export type TodayInfo = {
    headerText: string;
    status: TodayStatus;
    items: {
        text: string;
        value: number;
    }[];
    route?: string;
}[];


// type BooleanDictionary = 

export class DailyEntryViewModel extends BaseViewModel {

    public static get TypeName() { return Models.DailyEntry; };
    public get TypedData() { return ((this.Data as unknown) as DailyEntry); }

    public static CreateKey = DailyEntry.CreateKey;

    public static Manager = new ModelManager<DailyEntryViewModel>({
        createFN:
            async (options?: IEntityConstructorOptions) => {

                var builder = DataEntityBase.ConstructorOptionsBuilder(options);
                builder.addProp(BaseProperties.id, options?.sourceObject?.id ?? DailyEntry.CreateId(GetToday().toISOString()));
                var retVal = new DailyEntryViewModel(builder.construct());
                return retVal;

            },
        idFromKeyFN: (key: string) => DailyEntry.CreateId(key),
        typeName: Models.DailyEntry,
    });

    public static get DateList() {
        var ids = DataServices.Raw.allIdsByType(Models.DailyEntry);
        var retVal = ids.map((id) => DataEntityBase.KeyFromId(id));
        return retVal;

    };



    /***************************************************************
    *
    * Route related functions
    *
    ****************************************************************/

    public static GetRoute = async (date: Date) => {

        var vm = await DailyEntryViewModel.Manager.GetOrCreateByKey(GetCorrelation(), DailyEntry.CreateKey(date), DailyEntry.OptionsFromDate(date));
        return vm.Route;;
    }

    public get BaseRoute() {
        return `/journal/daily/${this.TypedData.date.toISOString()}`;
    }

    public get Route() {
        if (this.TypedData.viewCurentFocus === CurrentDaysFocus.Complete)
            return `${this.BaseRoute}/${CurrentDaysFocus.Review1}`;
        return `${this.BaseRoute}/${this.TypedData.viewCurentFocus}`;
    }

    public static EditSummaryRoute(date: Date) {
        return `/journal/daily/${date.toISOString()}/${CurrentDaysFocus.Review1}`;
    }











    public get TodayInfo(): TodayInfo {

        const Status = (myFocus: CurrentDaysFocus, myOtherFocus?: CurrentDaysFocus): TodayStatus => {

            var comparison = CompareFocus(myFocus, this.TypedData.viewCurentFocus);
            var otherComparison = undefined;
            if (myOtherFocus)
                otherComparison = CompareFocus(myOtherFocus, this.TypedData.viewCurentFocus);
            if (comparison === 0 || (otherComparison !== undefined && otherComparison === 0))
                return "inProgress";
            else if (comparison > 0 && (otherComparison === undefined || otherComparison > 0))
                return "complete";
            else
                return "notStarted";
        }

        const calculateProgressFN = (
            items: any[],
            compFn: (item?: any) => boolean
        ) => {
            if (items.length === 0)
                return 0;

            var total = 0;
            var completed = 0;
            for (let item of items) {
                total++;
                if (compFn(item))
                    completed++;
            }

            return (completed / total) * 100;
        }

        const calculateExecutionProgress = (items: ItemsManager<SimpleTextViewModel>) => {
            return calculateProgressFN(items.values, (item) => item?.TypedData.isComplete === true)
        }

        // const calculateSimpleEntryProgress = (items: ItemsManager<SimpleTextViewModel>) => {
        //     return calculateProgressFN(items.values, (item) => item?.TypedData.text !== "")
        // }


        var retVal: TodayInfo = [
            {
                headerText: "Craft a great day",
                status: Status(CurrentDaysFocus.Morning),
                items: [
                    // { text: "Gratitude", value: calculateSimpleEntryProgress(this.gratefulItems)},
                    // { text: "Great elements", value: calculateSimpleEntryProgress(this.greatItems)},
                    // { text: "Outcomes", value: calculateSimpleEntryProgress(this.outcomesItems) },
                    // { text: "Tasks", value: calculateSimpleEntryProgress(this.mostImportantTasks) }
                ]
            },
            {
                headerText: "Make it a great day",
                status: Status(CurrentDaysFocus.Execution),
                items: [
                    // { text: "Great elements", value: calculateExecutionProgress(this.greatItems) },
                    { text: "Outcomes", value: calculateExecutionProgress(this.outcomesItems) },
                    { text: "Tasks", value: calculateExecutionProgress(this.mostImportantTasks) }
                ]
            },
            {
                headerText: "Reflect on your day",
                status: Status(CurrentDaysFocus.Review1, CurrentDaysFocus.Review2),
                items: [
                    // { text: "Magic Moments", value: calculateSimpleEntryProgress(this.magicMomentsItems) },
                    // { text: "Even Better", value: calculateSimpleEntryProgress(this.evenBetterIfItems) },
                    // {text : "Magic Moments", value: this.magicMomentsItems.values.length > 0 ? 100 : 0},

                ]
            }
        ];


        if (this.recapForToday) {

            const status: TodayStatus = this.recapForToday.TypedData.status === RecapStatus.Complete ? "complete" : (
                this.TypedData.viewCurentFocus === CurrentDaysFocus.Complete ? "inProgress" : "notStarted"
            );

            retVal.push({
                headerText: (JournalStrings.Home.TodaySection.ReviewItem as any)[this.recapForToday.TypedData.entryType],
                status: status,
                items: [

                ],
                route: this.recapForToday.EditRoute
            })
        }


        return retVal;
    };







    public get isCompletable(): boolean {

        const isDescribed = this.TypedData.daysEvents.length > 0;

        return (
            this.isHighlightsWritten &&
            isDescribed
        )

    }

    public get isHighlightsWritten(): boolean {

        const magicMoments = this.magicMomentsItems.values.filter((item) => item.TypedData.text.length > 0);
        const accomplishments = this.achievementsItems.values.filter((item) => item.TypedData.text.length > 0);
        const isScored = this.TypedData.score >= 0;

        return (
            magicMoments.length > 0 &&
            accomplishments.length > 0 &&
            isScored
        );
    }

    public get IsReviewable(): boolean {

        return (
            this.TypedData.viewCurentFocus === CurrentDaysFocus.Complete &&
            this.isCompletable
        );
    }


    public get IsMorningContinueDisabled(): boolean {

        const checkList = (items: ItemsManager<SimpleTextViewModel> | ItemsManager<SimpleTextViewModel>) => {
            if (items.values.length === 0)
                return true;

            for (let item of items.values) {
                if (item.TypedData.text.length === 0)
                    return true;
            }

            return false;
        };

        var isReadyGrateful = checkList(this.gratefulItems);
        var isReadyOutcomes = checkList(this.outcomesItems);
        var isReadyMostImportant = checkList(this.mostImportantTasks);

        return isReadyGrateful || isReadyOutcomes || isReadyMostImportant;

    }
    previousIsMorningContinueDisabled: boolean = false;





    public onTypedDataChanged = async (props: IProperyChangedArgs) => {

        if (
            !(
                props.property === DailyEntryProperties.daysEvents
                || props.property === DailyEntryProperties.magicMomentsIds
                || props.property === DailyEntryProperties.acomplishmentsIds
                || props.property === DailyEntryProperties.viewCurentFocus
                || props.property === DailyEntryProperties.score
                || props.property === 'isHydrated'
            )
        )
            return;

        var recapKey = RecapEntry.CreateKey(this.TypedData.date, RecapEntryType.Day);
        var recap = await RecapEntriesViewModel.Manager.GetItemByKey(GetCorrelation(), recapKey);
        var correlation = GetCorrelation();


        // If we already have a reviewEntry, then we don't need to create a new one 
        //
        if (!recap) {
            //
            // Create the item and set it's properties
            //
            var optionsBuilder = RecapEntry.OptionsFromKey(recapKey);
            optionsBuilder.addProp(RecapEntryProperties.endDate, this.TypedData.date);
            optionsBuilder.addProp(RecapEntryProperties.startDate, this.TypedData.date);
            optionsBuilder.addProp(RecapEntryProperties.entryType, RecapEntryType.Day);
            var options = optionsBuilder.construct();
            recap = await RecapEntriesViewModel.Manager.GetOrCreateByKey(correlation, recapKey, options);
            if (!recap)
                throw new Error("Failed to create recap entry");
        }


        // We should only create it if the day is completed
        //
        if (this.TypedData.viewCurentFocus !== CurrentDaysFocus.Complete || this.TypedData.status !== "Complete") {
            return;
        }

        //
        // If we've ever hit complete, we will have a recap entry to update when
        // they go back to edit it.
        //        
        await recap.Hydrate(correlation);
        recap.selectedAccomplishments.values = this.achievementsItems.values;
        recap.selectedMagicMoments.values = this.magicMomentsItems.values;
        recap.TypedData.entry = this.TypedData.daysEvents;
        recap.TypedData.score = this.TypedData.score;
        if (this.TypedData.viewCurentFocus === CurrentDaysFocus.Complete)
            recap.TypedData.status = RecapStatus.Complete;

    }


    private async asyncGetExtraTodayItems() {
        const possibleRecapTypes = [
            RecapEntryType.Week,
            RecapEntryType.Month,
            RecapEntryType.Quarter,
            RecapEntryType.Year
        ];

        const correlation = GetCorrelation();
        const allRecaps = await RecapEntriesViewModel.Manager.GetAllItems(correlation);
        const today = GetToday();

        for (let type of possibleRecapTypes) {

            var periodDates = RecapEntriesViewModel.GetPeriodDates(type, today, PeriodType.Previous);

            //
            // TODO: First check to see if we've completed the review 
            //
            var existingRecap = allRecaps.find((recap) =>
                recap.TypedData.DateRange.start.getTime() === periodDates.start.getTime()
                && recap.TypedData.DateRange.end.getTime() === periodDates.end.getTime()
            );
            if (existingRecap) {
                await existingRecap.Hydrate(correlation);
                //
                // Check to make sure that at least half of the days have completed children
                //
                let childCount = 0;

                for (let child of existingRecap.ChildRecaps.values) {
                    await child.Hydrate(correlation);
                    if (child.TypedData.status === RecapStatus.Complete)
                        childCount++;
                }

                // let periodDays = (periodDates.end.getTime() - periodDates.start.getTime()) / (1000 * 60 * 60 * 24) + 1;

                if (childCount <= 1)
                    return;

                if (this.recapForToday !== existingRecap) {
                    this.recapForToday = existingRecap;

                    const doChildPropChanged = (e: IProperyChangedArgs) => {
                        if (e.property === RecapEntryProperties.status || e.property === 'isHydrated')
                            this.FireChanged('TodayInfo');
                    };
                    this.recapForToday.TypedData.PropertyChanged.Subscribe(doChildPropChanged);
                    this.recapForToday.PropertyChanged.Subscribe((arg) => {
                        if (arg.property === 'Data')
                            this.recapForToday?.TypedData.PropertyChanged.Subscribe(doChildPropChanged);
                    });
                }
            }
        }

    }
    private recapForToday: RecapEntriesViewModel | undefined = undefined;



    protected CreateData(watcher: BasicEntityWatcher, options?: IConstructorOptions) {
        return DailyEntry.Create(watcher, options);
    }

    protected async doHydrate(_correlation: ICorrelation) {
        if (this.TypedData.date.getTime() === GetToday().getTime())
            await this.asyncGetExtraTodayItems();
    }

    protected onReplacedData(_oldData?: DataEntityBase, _newData?: DataEntityBase) {
        this.recapForToday = undefined;
    }

    

    private constructor(options?: IEntityConstructorOptions) {
        super(options);

        this.gratefulItems = new ItemsManager(
            {
                typeName: Models.SimpleText,
                idMGR:
                {
                    getKeys: () => { return this.TypedData.gratefulIds },
                    setKeys: (value) => {
                        this.TypedData.gratefulIds = value
                    }
                }
            }
        );

        //
        // #region Initialize the items managers
        //
        this.greatItems = new ItemsManager(
            {
                typeName: Models.SimpleText,
                idMGR:
                {
                    getKeys: () => { return this.TypedData.greatIds },
                    setKeys: (value) => {
                        this.TypedData.greatIds = value
                    }
                }
            }
        );

        this.outcomesItems = new ItemsManager(
            {
                typeName: Models.SimpleText,
                idMGR:
                {
                    getKeys: () => { return this.TypedData.outcomesIds },
                    setKeys: (value) => {
                        this.TypedData.outcomesIds = value
                    }
                }
            }
        );

        this.mostImportantTasks = new ItemsManager(
            {
                typeName: Models.SimpleText,
                idMGR:
                {
                    getKeys: () => { return this.TypedData.mostImportantTaskIds },
                    setKeys: (value) => {
                        this.TypedData.mostImportantTaskIds = value
                    }
                }
            }
        );

        this.magicMomentsItems = new ItemsManager(
            {
                typeName: Models.SimpleText,
                idMGR:
                {
                    getKeys: () => { return this.TypedData.magicMomentsIds },
                    setKeys: (value) => {
                        this.TypedData.magicMomentsIds = value
                    }
                }
            }
        );

        this.achievementsItems = new ItemsManager(
            {
                typeName: Models.SimpleText,
                idMGR:
                {
                    getKeys: () => { return this.TypedData.acomplishmentsIds },
                    setKeys: (value) => {
                        this.TypedData.acomplishmentsIds = value
                    }
                }
            }
        );

        this.evenBetterIfItems = new ItemsManager(
            {
                typeName: Models.SimpleText,
                idMGR:
                {
                    getKeys: () => { return this.TypedData.evenBetterIfIds },
                    setKeys: (value) => {
                        this.TypedData.evenBetterIfIds = value
                    }
                }
            }
        );

        this.tomorrowOutcomesItems = new ItemsManager(
            {
                typeName: Models.SimpleText,
                idMGR:
                {
                    getKeys: () => { return this.TypedData.tomorrowsOutcomeIds },
                    setKeys: (value) => {
                        this.TypedData.tomorrowsOutcomeIds = value
                    }
                }
            }
        );

        this.anythingImportantItems = new ItemsManager(
            {
                typeName: Models.SimpleText,
                idMGR:
                {
                    getKeys: () => { return this.TypedData.anythingImportantIds },
                    setKeys: (value) => {
                        this.TypedData.anythingImportantIds = value
                    }
                }
            }
        );

        this.mostImportantTomorrowTasks = new ItemsManager(
            {
                typeName: Models.SimpleText,
                idMGR:
                {
                    getKeys: () => { return this.TypedData.mostImportantTaskTomorrowIds },
                    setKeys: (value) => {
                        this.TypedData.mostImportantTaskTomorrowIds = value
                    }
                }
            }
        );

        


        //
        // #endregion
        //
        this.Hydrate(GetCorrelation());

        this.HydratePromise.then(
            () => {

                const doDataPropChanged = (e: IProperyChangedArgs) => this.onTypedDataChanged(e);
                this.TypedData.PropertyChanged.Subscribe(doDataPropChanged);


                const onPropertyChanged = (e: IProperyChangedArgs) => {

                    if (e.property === 'isHighlightsWritten'
                        || e.property === 'isCompletable'
                        || e.property === 'IsReviewable'
                    ) {
                        return;
                    }
                    else if (e.property === 'Data') {
                        this.TypedData.PropertyChanged.Subscribe(doDataPropChanged);
                        return;
                    }

                    this.FireChanged("isHighlightsWritten");
                    this.FireChanged("isCompletable");
                    this.FireChanged("IsReviewable");
                }

                this.PropertyChanged.Subscribe(onPropertyChanged);


                const wireChild = (children: ItemsManager<SimpleTextViewModel>, handler: () => void) => {


                    var previousChildren = children.values;

                    const doWiring = () => {
                        //
                        // Update the subscription to the PropertyChanged event of the children
                        //
                        const itemsToUnregistere = previousChildren.filter((entry) => !children.values.includes(entry));
                        const itemsToRegister = children.values.filter((entry) => !previousChildren.includes(entry));
                        itemsToUnregistere.forEach((entry) => {
                            entry.TypedData.PropertyChanged.Unsubscribe(handler);
                        });
                        itemsToRegister.forEach((entry) => {
                            entry.TypedData.PropertyChanged.Subscribe(handler);
                        });
                        previousChildren = children.values;
                    }

                    children.PropertyChanged.Subscribe((e) => {
                        if (e.property === 'values') {
                            doWiring();
                        }
                    });

                    doWiring();
                };

                let childWirings = [
                    { manager: this.gratefulItems, name: 'IsMorningContinueDisabled' },
                    { manager: this.outcomesItems, name: 'IsMorningContinueDisabled' },
                    { manager: this.mostImportantTasks, name: 'IsMorningContinueDisabled' },

                    { manager: this.magicMomentsItems, name: 'isHighlightsWritten' },
                    { manager: this.achievementsItems, name: 'isHighlightsWritten' },

                    { manager: this.evenBetterIfItems, name: 'isCompletable' }
                ];

                for (let wiring of childWirings) {
                    wireChild(wiring.manager, () => this.FireChanged(wiring.name));
                }


            }
        );

    }




    public gratefulItems: ItemsManager<SimpleTextViewModel>;
    public greatItems: ItemsManager<SimpleTextViewModel>;
    public outcomesItems: ItemsManager<SimpleTextViewModel>;
    public mostImportantTasks: ItemsManager<SimpleTextViewModel>;
    public magicMomentsItems: ItemsManager<SimpleTextViewModel>;
    public achievementsItems: ItemsManager<SimpleTextViewModel>;
    public evenBetterIfItems: ItemsManager<SimpleTextViewModel>;
    public tomorrowOutcomesItems: ItemsManager<SimpleTextViewModel>;
    public anythingImportantItems: ItemsManager<SimpleTextViewModel>;
    public mostImportantTomorrowTasks: ItemsManager<SimpleTextViewModel>;
}
